import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IVideoGallery, IVideoGalleryInitialState } from "./videogalleryModal";
import {
  ActiveInactiveVideoGallery,
  createVideoGallery,
  deleteVideoGallery,
  getAllActiveVideoGallerys,
  getAllVideoGallerys,
  getVideoGalleryByID,
  updateVideoGallery,
} from "./services/videogallery.services";

const initialState: IVideoGalleryInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  VideoGalleryID: null,
  VideoGalleryList: [],
  VideoGalleryDetail: {
    Title: "",
    PropertyID: null,
    VideoURL: "",
    IsActive: 1,
  },
};

const videoGallerySlice = createSlice({
  name: "videoGallery",
  initialState,
  reducers: {
    clearVideoGalleryDetails: (state) => {
      state.VideoGalleryDetail = initialState.VideoGalleryDetail;
    },
    setVideoGalleryID: (state, action) => {
      state.VideoGalleryID = action.payload;
    },
    clearVideoGalleryID: (state) => {
      state.VideoGalleryID = initialState.VideoGalleryID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllVideoGallerys.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllVideoGallerys.fulfilled,
      (state, action: PayloadAction<IVideoGallery[]>) => {
        state.loading = false;
        state.VideoGalleryList = action.payload || [];
      }
    );
    builder.addCase(getAllVideoGallerys.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.VideoGalleryList = [];
    });
    builder.addCase(createVideoGallery.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createVideoGallery.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createVideoGallery.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateVideoGallery.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateVideoGallery.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateVideoGallery.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteVideoGallery.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteVideoGallery.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteVideoGallery.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getVideoGalleryByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getVideoGalleryByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.VideoGalleryDetail = action.payload;
    });
    builder.addCase(getVideoGalleryByID.rejected, (state, action) => {
      state.formLoading = false;
      state.VideoGalleryDetail = initialState.VideoGalleryDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveVideoGallerys.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveVideoGallerys.fulfilled,
      (state, action: PayloadAction<IVideoGallery[]>) => {
        state.loading = false;
        state.VideoGalleryList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveVideoGallerys.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.VideoGalleryList = [];
    });
    builder.addCase(ActiveInactiveVideoGallery.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveVideoGallery.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveVideoGallery.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearVideoGalleryDetails,
  clearVideoGalleryID,
  setVideoGalleryID,
} = videoGallerySlice.actions;
export default videoGallerySlice.reducer;
